
var styleTag = document.createElement('style');
styleTag.id = 'coming-soon-size-hide';
styleTag.textContent = '.cs-hide-size { display: none !important; }';
document.head.appendChild(styleTag);


(function () {
  'use strict';

  const CONFIG = {
    notifyUrl: 'https://manage.kmail-lists.com/subscriptions/subscribe?a=Urpcfb&g=TT78nK',

    selectors: {
      comingSoonState: '#coming-soon-state',
      buyButtons:      '.product-form__submit, [name="add"], .shopify-payment-button, .dynamic-checkout-cart',
      dynamicCheckout: '.shopify-payment-button, .dynamic-checkout-cart',
      inventoryBadge: '.product__inventory, .product-inventory, [data-inventory], .js-inventory-tracking',
      lowStockMsg:     '.product__low-stock, .low-stock-message, [data-low-stock]',
      soldOutMsg:      '.product__sold-out, .sold-out-label, [data-sold-out]',
      quantityPicker: '.product-form__quantity, .quantity-selector, [data-quantity-input], .js-product-quantity-container',
      variantInput:    '[name="id"]',
    },

    transitionDuration: 280,
  };

  let isComingSoonActive = false;

  // Hide or show elements by selector
function setElementsVisibility(selectorString, hidden) {
  document.querySelectorAll(selectorString).forEach(function (el) {
    if (hidden) {
      if (el.style.display === 'none') return; // already hidden
      el.dataset.csOriginalDisplay = el.style.display || '';
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    } else {
      if (!el.hasAttribute('data-cs-original-display')) return; // not hidden by us
      el.style.display = el.dataset.csOriginalDisplay || '';
      el.removeAttribute('aria-hidden');
      delete el.dataset.csOriginalDisplay;
    }
  });
}

  // Show or hide the coming soon panel
  function setComingSoonVisible(visible) {
    var panel = document.querySelector(CONFIG.selectors.comingSoonState);
    if (!panel) return;

    if (visible) {
      panel.style.display = '';
      panel.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        panel.classList.add('is-visible');
      });
    } else {
      panel.classList.remove('is-visible');
      panel.setAttribute('aria-hidden', 'true');
      setTimeout(function () {
        panel.style.display = 'none';
      }, CONFIG.transitionDuration);
    }
  }

  // Get the currently selected color value
function getSelectedColor() {
  var colorInput = document.querySelector('input[type="radio"][name^="Color"]:checked, input[type="radio"][name^="Farbe"]:checked');
  if (colorInput) return colorInput.value;
  return '';
}

  // Hide size picker (all fieldsets after the first one)
function hideSizePicker() {
  setTimeout(function() {
    var fieldsets = document.querySelectorAll('fieldset.js-variant-radio-container');
    if (fieldsets.length > 1) {
      for (var i = 1; i < fieldsets.length; i++) {
        fieldsets[i].style.display = 'none';
      }
    }
  }, 150);
}

function showSizePicker() {
  var fieldsets = document.querySelectorAll('fieldset.js-variant-radio-container');
  if (fieldsets.length > 1) {
    for (var i = 1; i < fieldsets.length; i++) {
      fieldsets[i].style.display = '';
    }
  }
}

  function activateComingSoon() {
    isComingSoonActive = true;
    setComingSoonVisible(true);
    hideSizePicker();
    setElementsVisibility(CONFIG.selectors.buyButtons,      true);
    setElementsVisibility(CONFIG.selectors.dynamicCheckout, true);
    setElementsVisibility(CONFIG.selectors.inventoryBadge,  true);
    setElementsVisibility(CONFIG.selectors.lowStockMsg,     true);
    setElementsVisibility(CONFIG.selectors.soldOutMsg,      true);
    setElementsVisibility(CONFIG.selectors.quantityPicker,  true);
  }

function deactivateComingSoon() {
  isComingSoonActive = false;
  
  var panel = document.querySelector(CONFIG.selectors.comingSoonState);
  if (panel) {
    panel.classList.remove('is-visible');
    panel.setAttribute('aria-hidden', 'true');
    panel.style.display = 'none';
  }

  showSizePicker();
  setElementsVisibility(CONFIG.selectors.buyButtons,      false);
  setElementsVisibility(CONFIG.selectors.dynamicCheckout, false);
  setElementsVisibility(CONFIG.selectors.inventoryBadge,  false);
  setElementsVisibility(CONFIG.selectors.lowStockMsg,     false);
  setElementsVisibility(CONFIG.selectors.soldOutMsg,      false);
  setElementsVisibility(CONFIG.selectors.quantityPicker,  false);
}

  // Check if the selected color is in the coming soon list
  function evaluateComingSoonState() {
    var selectedColor = getSelectedColor();
    if (!selectedColor) return;

    var panel = document.querySelector('#coming-soon-state');
    if (!panel) return;

    var colorsRaw = panel.dataset.comingSoonColors || '';
    var colorsList = colorsRaw.split(',').map(function (c) { return c.trim().toLowerCase(); }).filter(Boolean);
    var isComingSoon = colorsList.indexOf(selectedColor.trim().toLowerCase()) !== -1;

    if (isComingSoon) {
      activateComingSoon();
    } else {
      deactivateComingSoon();
    }
  }

function bindEvents() {
  // Poll every 200ms to keep size picker and BIS trigger hidden when coming soon is active
  setInterval(function() {
    if (isComingSoonActive) {
      // Dawn
      var pillFieldsets = document.querySelectorAll('.product-form__input--pill');
      if (pillFieldsets.length > 1) {
        for (var i = 1; i < pillFieldsets.length; i++) {
          if (pillFieldsets[i].style.display !== 'none') {
            pillFieldsets[i].style.display = 'none';
          }
        }
      }
      // New theme
      var variantFieldsets = document.querySelectorAll('fieldset.js-variant-radio-container');
      if (variantFieldsets.length > 1) {
        for (var i = 1; i < variantFieldsets.length; i++) {
          if (variantFieldsets[i].style.display !== 'none') {
            variantFieldsets[i].style.display = 'none';
          }
        }
      }
      // BIS trigger
      var bisTrigger = document.querySelector('.BIS_trigger');
      if (bisTrigger && bisTrigger.style.display !== 'none') {
        bisTrigger.style.display = 'none';
      }
    }
  }, 200);

  // Color radio change
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[type="radio"][name^="Color"], input[type="radio"][name^="Farbe"]')) {
      setTimeout(evaluateComingSoonState, 150);
    }
  });

  // Notify button
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-coming-soon-notify]')) {
      e.preventDefault();
      window.open(CONFIG.notifyUrl, '_blank');
    }
  });
}
  function init() {
    var panel = document.querySelector('#coming-soon-state');
    if (!panel) return;

    bindEvents();
    evaluateComingSoonState(); // Check state on page load
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();